import api from "./Api";

class EstoqueService {
  GetEstoque(payload) {
    return api.get("/v1/estoque/" + payload).then((response) => {
      return response.data;
    });
  }

  PostEstoque(payload) {
    return api.post("/v1/estoque/", payload).then((response) => {
      return response.data;
    });
  }

  PutEstoque(payload) {
    return api.put("/v1/estoque/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteEstoque(payload) {
    return api.delete("/v1/estoque/" + payload).then((response) => {
      return response.data;
    });
  }

  GetEstoqueOData(payload) {
    return api.get("/OData/Estoque" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new EstoqueService();
